// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Database connectors type.
 */
export enum ConnectorTypesEnum {
  Postgres = 0,
  MySQL = 1,
  MsSQL = 2,
  MariaDB = 3,
  Oracle = 4,
  Clickhouse = 5,
  Druid = 6,
  Ignite = 7,
  Redshift = 8,
  BigQuery = 9,
  GoogleSheets = 10,
  ElasticSearch = 11,
  MongoDB = 12,
  Snowflake = 13
}
